import { Theme } from "@emotion/react";
import { Box, SxProps, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface IItemProps {
    label: string;
    image: string;
    link?: string;
    fontSize?: number;
    onClick?: any;
}

const imageContainerSx: SxProps<Theme> = {
  position: 'relative',
  cursor: 'pointer',
  '&:hover .item-label': {
    opacity: 1
  }
};

const imageSx: SxProps<Theme> = {
    width: '100%',
    borderRadius: '20px',
    display: 'block'
}

const labelSx: SxProps<Theme> = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgb(187, 68, 48, 0.8)',
    color: '#fff',
    textAlign: 'center',
    alignContent: 'center',
    borderRadius: '20px',
    opacity: 0,
    transition: 'opacity 0.3s ease'
}

const Item = (props: IItemProps) => {

    const {label, image, link, fontSize, onClick} = props;
    const navigate = useNavigate();

    const handleClick = () => {
        if (onClick) onClick();
        if (link) navigate(link);
    }

    return (
        <Box sx={imageContainerSx} onClick={handleClick}>

            <Box component="img" src={image} alt={label} sx={imageSx} />
            
            <Box sx={labelSx} className="item-label">
                <Typography gutterBottom component="div" width={'100%'} align={'center'}
                            fontFamily={'AllertaStencil'} fontSize={fontSize ?? 25}>
                    {label}
                </Typography>
            </Box>
        </Box>
    );
}

export default Item;